<!--
@负责人: zhijie.huang
@创建时间: 2018-11-08
@版本: v2.0.0
@描述: 图表多图列表
@使用方法:
<template>
  <chart-list :chart-data-list="chartDataList"></chart-list>
</template>
<script>
  import chartList from '@/components/chart/chart-config-list.vue'
  drawChart (dataList) {
    const list = []
    dataList.map((data, index) => {
      const chartData = {
        title: 'BSS_SAASLoginSuccess',
        kpiInfo: {
          appGroup: 'BSS',
          appName: 'log-admin',
          kpiKey: 'xxxxx'
        },
        chartId: `some-${index}`,
        chartData: {
          rows: data,
          columns: ['eventTime', 'value'],
          formatMap: {
            eventTime: 'TIME'
          }
        }
      }
      list.push(chartData)
    })
    this.chartDataList = list
  }
</script>
@参数说明:
// 图表数据数组
chartDataList = [chartItem]，chartItem 参考 chart-config.vue
@事件说明
// 点击了右上角的按钮，回传 index,data,kpiInfo 默认跳转告警策略页面
chart-conf-click
-->
<style>
.chart-config-list {
  margin-top: 30px;
}
.chart-config-list__item {
  display: inline-block;
  margin: 0 16px 16px 0;
  width: 400px;
  height: 260px;
  vertical-align: middle;
}

</style>
<template>
  <ul class="chart-config-list">
    <li v-for="(item, index) in chartDataList" class="chart-config-list__item" :key="index">
      <chart-config :ref="item.chartId"
        :icon="icon"
        :chart-index="index" 
        :chart-id="item.chartId" 
        :title="item.title"
        :chart-data="item.chartData" 
        :chart-style="styleList[index]"
        :click-fun="onItemClick"
        :clickable="true"
        :show-color-icon="true">
      </chart-config>
    </li>
  </ul>
</template>
<script type="text/javascript">
import AlarmStrategyBiz from '@/logic/systemSetting/alarmStrategyBiz'
import tab from '@/views/layout/components/setTab'
import chartConfig from './chart-config'
import { extend } from '@/utils/tool'
const CHART_STYLE = {
  grid: {
    left: '4%',
    bottom: '5%',
    top: '14%',
    right: '6%',
    containLabel: true
  },
  toolbox: {
    feature: {
      dataZoom: {
        yAxisIndex: 'none'
      },
      restore: {}
    },
    right: '2%'
  },
  legend: {
    data: [],
    top: 4
  }
}
export default {
  components: {
    chartConfig
  },
  data () {
    const that = this
    return {
      icon: {
        label: that.$t('common.edit'),
        classname: 'icon-xiugai'
      },
      styleList: []
    }
  },
  props: ['chartDataList'],
  watch: {
    chartDataList: {
      deep: true,
      handler: function (val) {
        val.map(item => {
          const style = extend(true, {}, CHART_STYLE)
          this.styleList.push(this.handleLegend(style, item.chartData))
        })
      }
    }
  },
  methods: {
    onItemClick (index) {
      this.$emit('chart-conf-click', {
        index: index,
        data: this.chartDataList[index]
      })
      let kpiInfo = this.chartDataList[index].kpiInfo
      if (kpiInfo) {
        AlarmStrategyBiz.findAlarmStrategyId({
          group: kpiInfo.appGroup,
          appName: kpiInfo.appName,
          kpiKey: kpiInfo.kpiKey,
          siteCode: kpiInfo.siteCode
        }).then((data) => {
          let strategyInfo = data
          if (strategyInfo.length > 0 && strategyInfo[0].alarmCode) {
            this.$router.push({ path: `/home/alarmStrategy/editStrategy?alarmCode=${strategyInfo[0].alarmCode}` })
            tab.selectTab('alarmStrategy')
          } else {
            this.$router.push({ path: `/home/alarmStrategy/addStrategy?appName=${kpiInfo.appName}&appGroup=${kpiInfo.appGroup}&kpiKey=${kpiInfo.kpiKey}&sourceType=1` })
            tab.selectTab('alarmStrategy')
          }
        })
      }
    },
    handleLegend (style, chartData) {
      if (chartData.labelMap && Object.keys(chartData.labelMap).length > 1) {
        Object.keys(chartData.labelMap).map(item => {
          style.legend.data.push(chartData.labelMap[item])
        })
      }
      return style
    }
  },
  mounted () {
  }
}
</script>